import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';

export const QRCode = QRCodeCanvas;
export { QRCodeSVG };
